import axios from 'axios'

const CustomerCropHistoryService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('admin/customer-crop-histories', { params })
  },

  async histories (params = {}) {
    return axios.get('admin/reports/customer-crop-histories', { params })
  },

  async show (id) {
    return axios.get(`admin/customer-crop-histories/${id}`)
  },

  async post (params = {}) {
    return axios.post('admin/customer-crop-histories', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/customer-crop-histories/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/customer-crop-histories/${data.id}`, { data })
  }
}

export default CustomerCropHistoryService
